export default __webpack_public_path__ + "static/sust-second-fd177e9c09b9a88a9ea9ad0372d40ea3.png";